export default {
  "Connect Wallet": "Kết nối ví",
  "Loading":"Đang tải...",
  "Purchase Quantity": "Số lượng mua",
  "Total Amount": "Tổng số tiền",
  "Payment Method": "Phương thức thanh toán",
  "Fee": "Phí",
  "Purchase": "Mua",
  "Select Payment Method": "Chọn phương thức thanh toán",
  "Language Switch": "Chuyển đổi ngôn ngữ",
  "Mall": "Trung tâm mua sắm",
  "STAR Purchase": "Mua STAR",
  "Order Details": "Chi tiết đơn hàng",
  "My Orders": "Đơn hàng của tôi",
  "Order Confirmation Page": "Trang xác nhận đơn hàng",
  "Product Details": "Chi tiết sản phẩm",
  "Store Details": "Chi tiết cửa hàng",
  "Staking MUSE":"Staking MUSE",
  "My Stake":"Staking của tôi",
  "Redeemable Time":"Thời gian có thể đổi",
  "Redeem":"Đổi",
  "Stake":"Stake",
  "How to Obtain MUSE":"Làm thế nào để có MUSE",
  "Activity Rules":"Quy tắc hoạt động",
  "Stake Amount":"Số lượng stake",
  "Please Enter Amount":"Vui lòng nhập số lượng",
  "Balance":"Số dư",
  "Redeem Amount":"Số lượng đổi",
  "Confirm":"Xác nhận",
  "Cancel":"Hủy",
  "Staking MUSE can increase the voting power for activities on the StarNest platform, allowing you to vote for your favorite participants.":"Staking MUSE có thể tăng quyền bỏ phiếu cho các hoạt động trên nền tảng StarNest, cho phép bạn bình chọn cho thí sinh yêu thích.",
  "Rule1":"1. Thông qua staking MUSE, tăng trọng số phiếu bầu trong các hoạt động của StarNest (xem mô tả hoạt động tương ứng).",
  "Rule2":"2. MUSE đã stake có thể được đổi bất kỳ lúc nào sau khi hoạt động kết thúc.",
  "Rule3":"3. Staking MUSE cũng cho phép tham gia quản trị nền tảng và các hoạt động khác.",
  "Rule4":"4. Quyền giải thích cuối cùng thuộc về nền tảng StarNest.",
  "Staked":"Đã stake",
  "Redeemed":"Đã đổi",
  "Payment":"Thanh toán",
  "Next step":"Bước tiếp theo",
  "Amount":"Số tiền",
  "Copied":"Đã sao chép",
  "QRCodeTip":"Vui lòng quét mã QR hoặc sao chép địa chỉ để thanh toán đơn hàng. Nếu số tiền thanh toán không đủ, đơn hàng sẽ thất bại và không được hoàn lại.",
  "Scan QR code to pay":"Quét mã QR để thanh toán",
  "DownloadTip":"Quét để tải ứng dụng StarNest và trải nghiệm ngay",
  "Save QR code":"Lưu mã QR",
  "Minimum":"Tối thiểu",
  "All":"Tất cả",
  "Failed to create order":"Tạo đơn hàng thất bại",
  "The order was created successfully and payment is being redirected":"Đơn hàng đã được tạo thành công, đang chuyển hướng thanh toán",
  "Payment details":"Chi tiết thanh toán",
  "Address management":"Quản lý địa chỉ",
  "New address":"Địa chỉ mới",
  "Delete address":"Xóa địa chỉ",
  "Are you sure you want to delete this address?":"Bạn có chắc muốn xóa địa chỉ này?",
  "First name":"Họ",
  "Last name":"Tên",
  "Please enter":"Vui lòng nhập",
  "Phone":"Số điện thoại",
  "Country":"Quốc gia/Khu vực",
  "State/Province":"Bang/Tỉnh",
  "City":"Thành phố",
  "Address":"Địa chỉ chi tiết",
  "Zip code":"Mã bưu chính",
  "Email":"Email",
  "Save address":"Lưu địa chỉ",
  "The address has been edited, do you want to save it?":"Địa chỉ đã được chỉnh sửa, bạn có muốn lưu lại không?",
  "Return":"Quay lại",
  "Save":"Lưu",
  "Waiting for payment":"Chờ thanh toán",
  "Please complete the payment within time as soon as possible":"Vui lòng hoàn tất thanh toán trong vòng {time} sớm nhất có thể",
  "Expired":"Đã hết hạn",
  "Order ID":"Mã đơn hàng",
  "Order total":"Tổng đơn hàng",
  "Order time":"Thời gian đặt hàng",
  "Payment method":"Phương thức thanh toán",
  "Billing address":"Địa chỉ thanh toán",
  "Switch address":"Chuyển địa chỉ",
  "Pay":"Xác nhận thanh toán",
  "Deleted":"Đã xóa",
  "Please fill in the form completely":"Vui lòng điền đầy đủ biểu mẫu",
  "Create success":"Tạo thành công",
  "Update success":"Cập nhật thành công",
  "Insufficient balance":"Số dư không đủ",
  "No address filled in yet":"Chưa nhập địa chỉ",
  "Choose country":"Chọn quốc gia",
  "Please enter search keywords":"Vui lòng nhập từ khóa tìm kiếm",
  "Payment successful":"Thanh toán thành công",
  "Please check the balance in your wallet":"Vui lòng kiểm tra số dư trong ví",
  "Finish":"Hoàn thành",
  "Payment failed":"Thanh toán thất bại",
  "Please complete the payment in time in My Order-Waiting for Payment":"Vui lòng hoàn tất thanh toán đúng hạn trong Đơn hàng của tôi - Chờ thanh toán",
  "Verification": "Vui lòng hoàn tất xác minh bảo mật",
  "Slide": "Kéo sang phải để hoàn tất xác minh",
  "Point": "Vui lòng nhấn theo thứ tự",
  "Verify success": "Xác minh thành công",
  "Verify fail": "Xác minh thất bại",
  "Uploading":"Đang tải lên",
  "Upload payment voucher":"Tải lên chứng từ thanh toán",
  "Submission successful, please check the order later":"Gửi thành công, vui lòng kiểm tra đơn hàng sau",
  "Confirm submission":"Xác nhận gửi",
  "Detail":"Chi tiết",
  "Rate tip":"Tùy theo phương thức thanh toán, giá vé có thể khác nhau do tỷ giá. Số tiền cuối cùng theo thanh toán thực tế.",
  "Please log in":"Vui lòng đăng nhập",
  "Insufficient product inventory":"Hàng tồn kho không đủ",
  "Showtime":"Suất chiếu",
  "Ticket file":"Loại vé",
  "Sold out":"Hết vé",
  "Limit tickets per order":"Mỗi đơn hàng giới hạn {num} vé",
  "Please select region":"Vui lòng chọn khu vực",
  "Please fill in the correct email address":"Vui lòng nhập đúng địa chỉ email",
  "Delivery method":"Phương thức giao hàng",
  "E-ticket":"Vé điện tử",
  "Direct entry":"Vào trực tiếp",
  "After payment is successful, no need to pick up the ticket, go to the ticket folder to check the admission voucher":"Sau khi thanh toán thành công, không cần lấy vé, hãy vào mục vé để xem phiếu vào cửa",
  "Contact person":"Người liên hệ",
  "Name":"Họ tên",
  "Please fill in the contact name":"Vui lòng nhập tên người liên hệ",
  "Region":"Khu vực",
  "Please enter the mobile number":"Vui lòng nhập số điện thoại",
  "Please fill in the email":"Vui lòng nhập email",
  "The ticket verification code will be sent to your email via":"Mã xác thực vé sẽ được gửi đến email của bạn",
  "Details":"Chi tiết",
  "Submit order":"Gửi đơn hàng",
  "Price details":"Chi tiết giá",
  "The actual discount amount is subject to the following single page":"Số tiền giảm giá thực tế dựa trên trang đặt hàng",
  "Product information":"Thông tin sản phẩm",
  "STAR deduction":"Khấu trừ STAR",
  "Credit Card":"Thẻ tín dụng",
  "Payment Platform":"Nền tảng thanh toán",
  "On-Chain Payment":"Thanh toán trên chuỗi",
  "Other":"Khác",
  "No refunds":"Không hỗ trợ hoàn tiền",
  "Transferable":"Có thể chuyển nhượng",
  "Not transferable":"Không thể chuyển nhượng",
  "Ended":"Đã kết thúc",
  "Countdown":"Đếm ngược",
  "Please select the ticket file":"Vui lòng chọn loại vé",
  "Insufficient commodity inventory":"Hàng hóa không đủ",
  "Please go to log in":"Vui lòng đăng nhập",
  "Integral Mall":"Cửa hàng điểm thưởng",
  "All Products":"Tất cả sản phẩm",
  "Integral Records":"Lịch sử điểm",
  "Transaction Details":"Chi tiết giao dịch",
  "what":"MUSE là gì?",
  "museIntro":"MUSE là token ARC20 phát hành trên Armonia Meta Chain, tổng cung 2,1 tỷ, 80% token MUSE được khai thác qua hệ sinh thái.",
  "museUse":"MUSE có tác dụng gì?",
  "copyrightStaking":"Staking bản quyền",
  "copyrightStaking1":"Stake MUSE vào NFT bản quyền (AI metaverse, chân dung, âm thanh, video, v.v.) của nghệ sĩ hợp tác để chia sẻ lợi nhuận bản quyền.",
  "vote":"Bỏ phiếu cuộc thi",
  "vote1":"Staking MUSE có thể nhận thêm quyền bỏ phiếu trong STAR NEST WAR, tham gia bỏ phiếu ở các giai đoạn của cuộc thi.",
  "product":"Mua sản phẩm",
  "product1":"Được sử dụng để mua sản phẩm đặc biệt trong hệ sinh thái, chẳng hạn NFT phiên bản giới hạn của nghệ sĩ, hàng hóa giới hạn, vé giới hạn (vé early bird, vé VIP, v.v.).",
  "more":"Nhiều cách chơi hơn (liên tục cập nhật)",
  "more1":"Hệ sinh thái game: Game hợp tác được cấp phép có thể sử dụng bản quyền nghệ sĩ, hàng hóa liên quan được thanh toán bằng MUSE.",
  "more2":"Hỗ trợ nghệ sĩ: MUSE có thể được sử dụng để thưởng cho nghệ sĩ và nhà sáng tạo âm nhạc.",
  "activity":"Hoạt động đặc biệt",
  "activity1":"Nhận lời mời tham gia các hoạt động cụ thể.",
  "how":"Làm thế nào để có MUSE?",
  "how1":"Thông qua việc tham gia private sale sớm của MUSE.",
  "how2":"Thông qua sáng tạo tác phẩm, khi người dùng thưởng cho tác phẩm.",
  "how3":"Thông qua tham gia hoạt động (mua vé, mua hàng, sự kiện offline) để nhận airdrop.",
  "how4":"Nghe/Xem một số tác phẩm Audition và vừa thưởng thức vừa kiếm tiền",
  "Redeem now":"Đổi ngay",
  "Basic information":"Thông tin cơ bản"
}
